module.exports = __webpack_public_path__ + "img/ivan-pro.e9ac16ed.jpg";